import React, { useCallback } from 'react';
import { PiCopy } from 'react-icons/pi';
import { useMapContextMenu, CoordinateFeature } from './MapContextMenuContext';
import { MenuItem } from './MenuItem';
import { useSettings } from '../../Settings/SettingsProvider';
import { formatCoordinateForCopy } from '@ais-ui/utils';

interface CoordinateContextMenuItemsProps {
  coordinate: CoordinateFeature['data'];
}

export const CoordinateContextMenuItems = ({
  coordinate,
}: CoordinateContextMenuItemsProps) => {
  const { closeContextMenu } = useMapContextMenu();
  const { settings } = useSettings();

  const handleCopyCoordinates = useCallback(async () => {
    const format = settings['ribbonPlugin.settings']?.cursor_position_format;
    const formattedCoordinate = formatCoordinateForCopy(
      coordinate.longitude,
      coordinate.latitude,
      format,
    );

    if (formattedCoordinate) {
      await navigator.clipboard.writeText(formattedCoordinate);
    }

    closeContextMenu();
  }, [coordinate, settings, closeContextMenu]);

  return (
    <MenuItem onClick={handleCopyCoordinates}>
      <PiCopy className="h-4 w-4" />
      Copy Coordinate
    </MenuItem>
  );
};
